// Jul-2026 (User-Wunsch) — TÜV/HU-Prüfung für Verkaufsfahrzeuge.
// Spiegel der Backend-Logik in routers/dispo_common.tuev_check:
//   * eingetragener TÜV (tuev_until / next_inspection_date) → 3-Monats-Warnung
//   * kein TÜV → ab Erstzulassung im 2-Jahres-Zyklus grob kalkulieren (prüfen!)
//   * nichts hinterlegt → "unknown"
export function computeTuev(l) {
    if (!l) return null;
    // Jul-2026 (User-Vorgabe): Fahrzeuge bis 50 ccm UND/ODER bis 45 km/h
    // unterliegen NICHT der HU (Versicherungskennzeichen) — TÜV kann nicht ablaufen.
    const ccm = Number(l.displacement || l.engine_ccm || 0);
    const kmh = Number(l.max_speed_kmh || l.top_speed_kmh || 0);
    if ((ccm > 0 && ccm <= 50) || (kmh > 0 && kmh <= 45)) return { level: "exempt", dueDate: null, daysLeft: null, estimated: false };
    const parse = (s) => {
        if (!s) return null;
        const str = String(s).trim();
        if (/^\d{4}-\d{2}$/.test(str)) return new Date(`${str}-28T00:00:00`);
        const d = new Date(str.slice(0, 10) + "T00:00:00");
        return isNaN(d.getTime()) ? null : d;
    };
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let due = parse(l.tuev_until) || parse(l.next_inspection_date);
    let estimated = false;
    if (!due) {
        const ez = parse(l.first_registration_date);
        if (!ez) return { level: "unknown", dueDate: null, daysLeft: null, estimated: false };
        due = new Date(ez);
        let prev = null;
        while (due <= today) {
            prev = new Date(due);
            due.setFullYear(due.getFullYear() + 2);
        }
        estimated = true;
        // Kalkulierter Termin gerade erst verstrichen (< 3 Monate) → überfällig melden.
        if (prev && Math.round((today - prev) / 86400000) <= 92) due = prev;
    }
    const daysLeft = Math.round((due - today) / 86400000);
    const level = daysLeft < 0 ? "overdue" : daysLeft <= 92 ? "due_soon" : "ok";
    return { level, dueDate: due, daysLeft, estimated };
}

export function tuevLabel(t) {
    if (!t) return "";
    if (t.level === "exempt") return "Kein TÜV erforderlich (bis 50 ccm / 45 km/h, Versicherungskennzeichen)";
    const d = t.dueDate ? t.dueDate.toLocaleDateString("de-DE") : "";
    if (t.level === "unknown") return "TÜV unbekannt — kein Termin & keine EZ hinterlegt, bitte prüfen";
    const est = t.estimated ? " · grob ab EZ kalkuliert (2-Jahres-Zyklus), bitte prüfen" : "";
    if (t.level === "overdue") return `TÜV ABGELAUFEN am ${d}${est}`;
    if (t.level === "due_soon") return `TÜV fällig am ${d} (unter 3 Monate)${est}`;
    return `TÜV bis ${d}${est}`;
}
